// src/utils/apiClient.ts
import { authInterceptor } from "../../services/Authentication/authInterceptor";
import { config } from "../../config/env";

class ApiClient {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async request(endpoint: string, options: RequestInit = {}): Promise<Response> {
    const url = `${this.baseUrl}${endpoint}`;
    
    // Prepare request config
    const requestConfig: RequestInit & { url?: string } = {
      ...options,
      url,
    };

    // Intercept request to add auth headers
    const interceptedConfig = await authInterceptor.interceptRequest(requestConfig);
    
    // Make the request
    const response = await fetch(url, interceptedConfig);
    
    // Intercept response to handle token expiration and rate limiting
    return authInterceptor.interceptResponse(response, interceptedConfig);
  }

  async get(endpoint: string, options: RequestInit = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  async post(endpoint: string, data?: any, options: RequestInit = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async put(endpoint: string, data?: any, options: RequestInit = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async delete(endpoint: string, options: RequestInit = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }
}

export const apiClient = new ApiClient(config.api.baseUrl);
